document.addEventListener("DOMContentLoaded", function () {
  // Toggle main menu
  document.querySelector(".menu-ttl").addEventListener("click", function () {
    this.classList.toggle("is-active");
    document.querySelector(".main-menu").classList.toggle("active");
  });

  // Toggle submenus
  document.querySelectorAll(".accordion-toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function (event) {
      event.stopPropagation();
      let submenu = this.parentElement.nextElementSibling;
      if (submenu && submenu.tagName === "UL") {
        submenu.classList.toggle("active");
        this.classList.toggle("is-active");
      }
    });
  });

  // Ensure active menu expands
  document.querySelectorAll(".menu-item.active").forEach(function (activeItem) {
    let parentMenu = activeItem.closest("ul");
    if (parentMenu) {
      parentMenu.classList.add("active");
    }
  });

  document.querySelectorAll(".submenu-item.active").forEach(function (activeSubItem) {
    let parentMenu = activeSubItem.closest(".submenu");
    if (parentMenu) {
      parentMenu.classList.add("active");
      let parentButton = parentMenu.previousElementSibling.querySelector(".accordion-toggle");
      if (parentButton) {
        parentButton.classList.add("is-active");
      }
    }
  });
});
